export default {
    index(axios) {
        return axios({
            url: 'polls',
            method: 'GET'
        })
    },

    get(id, axios) {
        return axios({
            url: `polls/${id}/view`,
            method: 'GET'
        })
    },

    createPollFromNotification(pollId, patientId, signature, axios) {
        return axios({
            url: `polls/${pollId}/patients/${patientId}?signature=${signature}`,
            method: 'POST'
        })
    },

    nextQuestionFromNotification(url, axios) {
        return axios({
            url: url,
            method: 'GET'
        })
    },
    updateFromNotification(url, data, axios) {
        return axios({
            url: url,
            method: 'POST',
            data: data
        })
    },

    removeLastAnswerFromNotification(url, axios) {
        return axios({
            url: url,
            method: 'GET'
        })
    },


    add(data, axios) {
        return axios({
            url: `polls/add`,
            method: 'POST',
            data: data
        })
    },

    update(id, data, axios) {
        return axios({
            url: `polls/${id}/update`,
            method: 'POST',
            data: data
        })
    },

    getCreateForm(axios, pollId) {
        if(pollId) {
            return axios({
                url: `polls/${pollId}/edit`,
                method: 'GET'
            })
        }
        return axios({
            url: `polls/create`,
            method: 'GET'
        })
    },

    export(id, axios) {
        return axios({
            url: `polls/${id}/export`,
            method: 'GET',
            responseType: 'blob'
        })
    },

    archived(axios) {
        return axios({
            url: 'polls/archived',
            method: 'GET'
        })
    },

    delete(id, axios) {
        return axios({
            url: `polls/${id}/delete`,
            method: 'DELETE'
        })
    },

    restore(id, axios) {
        return axios({
            url: `polls/${id}/restore`,
            method: 'POST'
        })
    }
}
